import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ED0E00",
      "fill-rule": "evenodd",
      d: "M12 5.77a5.48 5.48 0 0 1 4.436-2.27c3.097 0 5.364 2.565 5.364 5.612 0 3.04-1.92 5.718-3.9 7.692-2.005 1.999-4.22 3.423-5.103 3.956a1.54 1.54 0 0 1-1.593 0c-.883-.534-3.099-1.959-5.104-3.958-1.98-1.975-3.9-4.655-3.9-7.694C2.2 6.061 4.47 3.5 7.565 3.5c1.823 0 3.432.896 4.435 2.27",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }